/**
 * @fileoverview This component renders the single-unit submenu (2-tier).
 * It is comprised of a curation page link and respective course links (separated by
 * a separator).
 */

import {useMenuProgressQuery} from "./courses-menu-progress-query.tsx";
import {SubMenuCourseLink} from "./submenu-course-link.tsx";
import {SubMenuCurationPageLink} from "./submenu-curation-page-link.tsx";
import type {SubmenuProps} from "./types.ts";

export const SingleCurationPageSubMenu = ({
    item,
    subItemRefs,
    mainSubMenuIdx,
    onClickLink,
    isOpen,
}: SubmenuProps): React.ReactElement | null => {
    const subjectPercentages = useMenuProgressQuery(
        {
            slugs: item.children.map(({slug}) => slug),
        },
        !isOpen,
    );
    return (
        <>
            <SubMenuCurationPageLink
                key={item.slug + `-${mainSubMenuIdx}-0`}
                item={item}
                subItemRefs={subItemRefs}
                index={0}
                onClickLink={onClickLink}
            />
            {item.children.map((child, idx) => (
                <SubMenuCourseLink
                    key={child.slug + `-${mainSubMenuIdx}-${idx + 1}`}
                    item={child}
                    subItemRefs={subItemRefs}
                    subjectPercentage={subjectPercentages[child.slug]}
                    index={idx + 1}
                    onClickLink={onClickLink}
                />
            ))}
        </>
    );
};
